<sb-checklist-item class="footer" [item]="item()" [expanded]="expanded()" [hideIsCompletedStatus]="true" />
